
// Fix: Cast import.meta to any to resolve TypeScript error regarding 'env' property
let rawUrl = (import.meta as any).env?.VITE_API_URL || 'http://localhost:3000';

// Remove trailing slash if present to prevent double slashes in requests
if (rawUrl.endsWith('/')) {
  rawUrl = rawUrl.slice(0, -1);
}

export const API_BASE_URL = rawUrl;

export const ADMIN_EMAILS: string[] = ((import.meta as any).env?.VITE_ADMIN_EMAILS || '')
  .split(',')
  .map((email: string) => email.trim())
  .filter((email: string) => email.length > 0);

// Debugging: Log the connected API to console
console.log(`%c🔌 Connected to Backend: ${API_BASE_URL}`, 'color: #059669; font-weight: bold; background: #ecfdf5; padding: 4px; border-radius: 4px;');

// Safety Check: Warn if the API URL seems to be pointing to the Dashboard itself
// This happens if user sets VITE_API_URL to dashboard.listingstudio.co
if (typeof window !== 'undefined' && window.location.origin === API_BASE_URL && !API_BASE_URL.includes('localhost')) {
    console.error("%c⚠️ CRITICAL CONFIG ERROR: VITE_API_URL is set to the same domain as the frontend!", "color: red; font-size: 16px; font-weight: bold;");
    console.error("The Frontend is trying to fetch data from itself (HTML) instead of the Backend (JSON). Change VITE_API_URL in Vercel to point to your Render Backend URL.");
}

export const CREDIT_PACKAGES = [
  {
    id: 'starter',
    name: 'Starter',
    price: 10,
    credits: 200,
    description: "Ideal for trying out AI tools or small one-off projects.",
    features: [
      'Generate ~8 AI Videos',
      'OR ~40 Design Extractions',
      'OR ~200 Background Removals',
      'Credits never expire'
    ],
    isPopular: false
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 40,
    credits: 1000,
    description: "Best value for growing POD sellers and content creators.",
    features: [
      'Generate ~40 AI Videos',
      'OR ~200 Design Extractions',
      'OR ~200 Mockup Generations',
      'Priority Processing',
      'Credits never expire'
    ],
    isPopular: true
  },
  {
    id: 'business',
    name: 'Business',
    price: 120,
    credits: 4000,
    description: "Maximum power for agencies and high-volume stores.",
    features: [
      'Generate ~160 AI Videos',
      'OR ~800 Design Extractions',
      'OR ~800 Mockup Generations',
      'Highest Priority Processing',
      'Credits never expire'
    ],
    isPopular: false
  }
] as const;

export const TOOL_COSTS = {
  clone: 5,
  redesign: 8,
  embroidery: 5,
  removebg: 1,
  mockup: 5,       // Per image
  upscale: 5,
  listing: 1,      // Reduced cost for text analysis only
  video_generation: 25, // Separate cost for video
  enhance: 5
};
